import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplyPipeModule } from '../../../takvim/apply.pipe';
import { DxButtonModule, DxPopupModule, DxToolbarModule, DxValidationGroupComponent, DxValidationGroupModule } from 'devextreme-angular';
import { ScreenService } from '../../../../services/screen.service';

@Component({
  selector: 'dk-password-popup',
  standalone: true,
  imports: [CommonModule,
    ApplyPipeModule,
    DxButtonModule,
    DxToolbarModule,
    DxPopupModule,
    DxValidationGroupModule
  ],
  templateUrl: './password-popup.component.html',
  styleUrls: ['./password-popup.component.scss'],
})
export class PasswordPopupComponent {
  @ViewChild('validationGroup', { static: true }) validationGroup: DxValidationGroupComponent;

  @Input() titleText = '';

  @Input() width = 480;

  @Input() height: string | number = 'auto';

  @Input() wrapperAttr: Record<string, string> = {};

  @Input() visible = false;

  @Input() isSaveDisabled = false;

  @Output() save = new EventEmitter();

  @Output() visibleChange = new EventEmitter<boolean>();

  constructor(protected screen: ScreenService) {
    console.log('PasswordPopupComponent')
   }

  isValid() {
    if (!this.validationGroup || !this.validationGroup.instance) {
      return false;
    }
    return this.validationGroup.instance.validate().isValid;
  }

  onSaveClick() {
    if(!this.isValid()) {
      return
    }

    this.save.emit();
    // Popup'ı burada kapatmıyoruz, parent component API çağrısı başarılı olduğunda kapatacak
  }

  close() {
    if (this.validationGroup && this.validationGroup.instance) {
      this.validationGroup.instance.reset();
    }
    this.visible = false;

    this.visibleChange.emit(this.visible);
  }

  getWrapperAttrs = (inputWrapperAttr:any) => {
    return {
      ...inputWrapperAttr,
      class: `${inputWrapperAttr.class} form-popup`,
    };
  }
}
